import { gettext } from '@eventbrite/i18n';
import { statusConstants } from '@eventbrite/eds-ticket-edit-card-content';

export const TIERED_TICKET_STATUS_PLACEMENT_DESCRIPTION = 'underPrice';
export const TIERED_TICKET_STATUS_PLACEMENT_REPLACE_QUANTITY =
    'replaceQuantity';

const MESSAGING_INFO_DEFAULTS = {
    placement: TIERED_TICKET_STATUS_PLACEMENT_REPLACE_QUANTITY,
    isDisabled: false,
    hideDescription: false,
};

export const TIERED_TICKET_SALES_STATUS_MAP = {
    [statusConstants.UNAVAILABLE_STATUS]: {
        ...MESSAGING_INFO_DEFAULTS,
        textWithPlaceholders: () => gettext('Unavailable'),
        isDisabled: true,
    },
    [statusConstants.SOLD_OUT_STATUS]: {
        ...MESSAGING_INFO_DEFAULTS,
        textWithPlaceholders: () => gettext('Sold Out'),
        hideDescription: true,
        isDisabled: true,
    },
    [statusConstants.ON_SALE_STATUS]: {
        ...MESSAGING_INFO_DEFAULTS,
        datePropKey: 'salesEnd',
        textWithPlaceholders: (date) =>
            gettext('Sales end on %(date)s', { date }),
        placement: TIERED_TICKET_STATUS_PLACEMENT_DESCRIPTION,
    },
    [statusConstants.SALES_END_SOON_STATUS]: {
        ...MESSAGING_INFO_DEFAULTS,
        datePropKey: 'salesEnd',
        textWithPlaceholders: (date) =>
            gettext('Sales end in %(date)s', { date }),
        placement: TIERED_TICKET_STATUS_PLACEMENT_DESCRIPTION,
    },
    [statusConstants.SALES_ENDED_STATUS]: {
        ...MESSAGING_INFO_DEFAULTS,
        textWithPlaceholders: () => gettext('Sales Ended'),
        isDisabled: true,
    },
    [statusConstants.SALES_START_SOON_STATUS]: {
        ...MESSAGING_INFO_DEFAULTS,
        datePropKey: 'salesStart',
        textWithPlaceholders: (date) =>
            gettext('Sales start in %(date)s', { date }),
    },
    [statusConstants.SALES_NOT_STARTED_STATUS]: {
        ...MESSAGING_INFO_DEFAULTS,
        datePropKey: 'salesStart',
        textWithPlaceholders: (date) =>
            gettext('Sales start on %(date)s', { date }),
    },
};
